export enum PinnedItemType {
  ResponseOption
}
